import PropTypes from 'prop-types';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import './RentableUnitPriceOffer.scss';

const RentableUnitPriceOffer = ({ price, priceWithoutOffer }) => {
  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';
  return (
    <div className="rentable-unit-offer-price">
      <div className="rentable-unit-offer-price__after">
        <span className="rentable-unit-offer-price__after__amount">
          {price}
        </span>
        <span>
          {isListingSimplificationHeaderVariant
            ? `/${trans('price_tag.label.per_month')}`
            : trans('property_show.book_now_card.per_month')}
        </span>
      </div>
      <div className="rentable-unit-offer-price__before">
        {priceWithoutOffer}
      </div>
    </div>
  );
};

RentableUnitPriceOffer.propTypes = {
  price: PropTypes.string.isRequired,
  priceWithoutOffer: PropTypes.string.isRequired
};

export default RentableUnitPriceOffer;
